"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogisticsApp = void 0;
var React = require("react");
var react_tabs_1 = require("react-tabs");
var generic_1 = require("../generic");
var SitePlanInformation_1 = require("./SitePlanInformation");
var SiteBookings_1 = require("./site_bookings/SiteBookings");
var mobx_react_1 = require("mobx-react");
var App_1 = require("../../App");
var SiteUserList_1 = require("./SiteUserList");
var ShowOption;
(function (ShowOption) {
    ShowOption[ShowOption["BOOKINGS"] = 0] = "BOOKINGS";
    ShowOption[ShowOption["SITE_PLAN"] = 1] = "SITE_PLAN";
    ShowOption[ShowOption["INVITE"] = 2] = "INVITE";
})(ShowOption || (ShowOption = {}));
var LogisticsApp = (function (_super) {
    __extends(LogisticsApp, _super);
    function LogisticsApp(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            tabIndex: parseInt(localStorage.getItem("gamification.logistics.tab")) ||
                ShowOption.BOOKINGS,
        };
        return _this;
    }
    LogisticsApp.prototype.setTabIndex = function (index) {
        this.setState(__assign(__assign({}, this.state), { tabIndex: index }));
        localStorage.setItem("gamification.logistics.tab", index.toString());
    };
    LogisticsApp.prototype.render = function () {
        var _this = this;
        var user = App_1.store.getMe();
        var _a = this.props, project_id = _a.project_id, is_project_admin = _a.is_project_admin;
        return (React.createElement(react_tabs_1.Tabs, { className: "logistics-tabs", selectedIndex: this.state.tabIndex, selectedTabClassName: "logistics-tabs-tab-active", selectedTabPanelClassName: "logistics-tabs-panel-active", onSelect: function (index) { return _this.setTabIndex(index); } },
            React.createElement(react_tabs_1.TabList, { className: "logistics-tabs-list" },
                React.createElement(react_tabs_1.Tab, { className: "logistics-tabs-tab" },
                    React.createElement(generic_1.Icon, { size: "2x", name: generic_1.Icons.calendar_day }),
                    React.createElement("br", null),
                    gettext("Bookings")),
                is_project_admin && (React.createElement(react_tabs_1.Tab, { className: "logistics-tabs-tab" },
                    React.createElement(generic_1.Icon, { size: "2x", name: generic_1.Icons.map_with_locations }),
                    React.createElement("br", null),
                    gettext("Site Plan"))),
                is_project_admin && (React.createElement(react_tabs_1.Tab, { className: "logistics-tabs-tab" },
                    React.createElement(generic_1.Icon, { size: "2x", name: generic_1.Icons.user_add }),
                    React.createElement("br", null),
                    gettext("Site Users")))),
            React.createElement(react_tabs_1.TabPanel, { className: "logistics-tabs-panel" },
                React.createElement(SiteBookings_1.SiteBookings, { project_id: project_id, user: user, is_admin: is_project_admin })),
            is_project_admin && (React.createElement(react_tabs_1.TabPanel, { className: "logistics-tabs-panel" },
                React.createElement(SitePlanInformation_1.SitePlanInformation, { project_id: project_id }))),
            is_project_admin && (React.createElement(react_tabs_1.TabPanel, { className: "logistics-tabs-panel" },
                React.createElement(SiteUserList_1.SiteUserList, { user: user, project_id: project_id })))));
    };
    LogisticsApp = __decorate([
        mobx_react_1.observer
    ], LogisticsApp);
    return LogisticsApp;
}(React.Component));
exports.LogisticsApp = LogisticsApp;
